"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPermanent = exports.unsetPermanent = exports.setPermanent = void 0;
const Record_1 = require("../../utils/Record");
const Logger_1 = require("../../Logger");
function setPermanent(actorId, key, value) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|setPermanent|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}|value#${value}`);
    (0, Record_1.setValue)(actor.permanents, key, value);
}
exports.setPermanent = setPermanent;
function unsetPermanent(actorId, key) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|unsetPermanent|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}`);
    delete actor.permanents[key];
}
exports.unsetPermanent = unsetPermanent;
function readPermanent(actorId, key, defaultValue) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|readPermanent|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}`);
    return (0, Record_1.getValueOrDefaultTo)(actor.permanents, key, defaultValue);
}
exports.readPermanent = readPermanent;
